module.exports = __webpack_public_path__ + "img/tod.df66965.svg";